const lang = {
  UZBEK: "UZBEK",
  RUSSIAN: "RUSSIAN",
  ENGLISH: "ENGLISH",

};

export default lang;
